import { createRoot } from 'react-dom/client';
import { StrictMode, Suspense } from 'react';
import { I18nProvider, createI18n, curriculum } from '@bino/utils/i18next';
import { Pending } from '@bino/utils/components/pending';
import { Curriculum, type CurriculumProps } from './components/curriculum/Curriculum';

const i18n = createI18n(curriculum);

type RenderAppProps = CurriculumProps;

export const renderApp = (id: string, props: RenderAppProps) => {
    const container = document.getElementById(id);
    if (!container) return;

    const root = createRoot(container);
    root.render(
        <StrictMode>
            <Suspense fallback={<Pending />}>
                <I18nProvider i18n={i18n}>
                    <Curriculum {...props} />
                </I18nProvider>
            </Suspense>
        </StrictMode>,
    );
};
